export default {
  menuItems: [
    {
      name: 'Loading Navbar Menu...',
      slug: 'loading',
      url: 'javascript:;',
      icon: 'LoaderIcon'
    }
  ]
}